export const addMinutes=(time, minutes)=>{
    var date = new Date(new Date('01/01/2015 ' + time).getTime() + minutes * 60000);
    var tempTime = ((date.getHours().toString().length === 1) ? '0' + date.getHours() : date.getHours()) + ':' +
      ((date.getMinutes().toString().length === 1) ? '0' + date.getMinutes() : date.getMinutes()) + ':' +
      ((date.getSeconds().toString().length === 1) ? '0' + date.getSeconds() : date.getSeconds());
    return tempTime;
}


export const getTimings = (start_time,end_time,interval) => {
    const timingsForSlots = [start_time];
    while (start_time !== end_time) {
        start_time = addMinutes(start_time, interval);
        timingsForSlots.push(start_time);
      }
    return timingsForSlots;
}